import styled from 'styled-components';

export const FavoriteProductItemContainer = styled('div')`
    margin-left: 42px;
    margin-bottom: 40px;
`;
